import {API} from "aws-amplify";

export async function getCall(path) {
    try {
        let data = await API.get('list', path, {})
        return {"data":data,"statusCode":1}
    } catch(e) {
        if (e.response.data) {
            alert(e.response.data.message);
        } else {
            alert("Something went wrong!");
        }
        console.log(e);
        return {"data":{},"statusCode":0}
    }
}

export async function listCall(path) {
    try {
        let data = await API.get('list', path, {})
        return {"data":data,"statusCode":1}
    } catch(e) {
        if (e.response.data) {
            alert(e.response.data.message);
        } else {
            alert("Something went wrong!");
        }
        console.log(e);
        return {"data":[],"statusCode":0}
    }
}

export async function postCall(path,data) {
    try {
        let res = await API.post('create', path, {
            body:{
              "entityData":data
            }
        })
        return {"data":res,"statusCode":1}
    } catch(e) {
        if (e.response.data) {
            alert(e.response.data.message);
        } else {
            alert("Something went wrong!");
        }
        return {"data":e,"statusCode":0}
    }
}

export async function putCall(path,data) {
    try {
        await API.put('update', path, {
            body:{
              "entityData":data
            }
        })
        return {"data":"Successfully updated!","statusCode":1}
    } catch(e) {
        if (e.response.data) {
            alert(e.response.data.message);
        } else {
            alert("Something went wrong!");
        }
        return {"data":e,"statusCode":0}
    }
}

export async function delCall(path) {
    try {
        let data = await API.del('delete', path, {});
        return {"data":data,"statusCode":1}
    } catch(e) {
        if (e.response.data) {
            alert(e.response.data.message);
        } else {
            alert("Something went wrong!");
        }
        return {"data":e,"statusCode":0}
    }
}